import React, { useState } from "react" // import Steps from "../../../components/Steps"
import Layout from "../../components/layout"
import { graphql } from "gatsby"
import get from "lodash/get"
import Seo from "../../components/seo"
import nl2br from "../../utils/nl2br"
import RetinaImageWrapper from "../../components/RetinaImage" // import * as styles from "./index.module.less"
import Form from "./components/_form"
import Steps from "../../components/Steps"
import OverviewItem from "../../components/OverviewItem"
import RichText from "./components/_RichText"
import AddOns from "./components/_AddOns"
import { FaqItem, FaqTitle } from "./components/_FAQ"
import CTABox from "../../components/CTABox"

export default (props) => {
  const [active, setActive] = useState("")
  const pageData = get(props, "data.cms.entry", {})

  const metaImage = get(pageData, "metaImage[0].url", "")
  const pageImage = get(pageData, "coverImage[0].url", "")

  return (
    <Layout mainClassName={""}>
      <Seo
        title={pageData.metaTitle || pageData.title}
        description={pageData.metaDescription}
        image={metaImage || pageImage}
        jsonSchema={pageData.jsonSchema}
      />
      <div className="container">
        <div className="row">
          <div className="col-xl-8">
            <h1>{nl2br(pageData.title)}</h1>
          </div>

          {pageData.section1Text && (
            <>
              <div className="col-12" />
              <div className="col-lg-9 mb-lg-4">
                <p>{nl2br(pageData.section1Text)}</p>
              </div>
            </>
          )}

          {get(pageData, "coverImage[0].url", false) &&
            get(pageData, "coverImageRetina[0].url", false) && (
              <div className="col-sm-12">
                <div className="cover-images single-images">
                  <RetinaImageWrapper
                    image={pageData.coverImage[0]}
                    retinaImage={pageData.coverImageRetina[0]}
                    className={"light-box-thumbnail"}
                  />
                </div>
              </div>
            )}
        </div>
      </div>

      {pageData.solutionPageData.map((section, idx) => {
        const handle = section.typeHandle
        switch (handle) {
          case "imageSection1":
            return <OverviewItem data={section} key={idx} />
          case "imageSection2":
            return <Steps data={section} key={idx} />
          case "cta1":
            return <OverviewItem noImage data={section} key={idx} />
          case "cta2":
            return <CTABox data={section} key={idx} />
          case "richTextField":
            return <RichText data={section} key={idx} />
          case "contactForm":
            return <Form data={section} key={idx} />
          case "featuresSection":
            return <AddOns data={section} key={idx} />
          case "faqTitle":
            return <FaqTitle data={section} key={idx} />
          case "faqItem":
            return (
              <FaqItem
                key={idx}
                data={section}
                id={`faq_item_${idx}_${section.id}`}
                setActive={setActive}
                active={active}
              />
            )
          default:
            return null
        }
      })}
    </Layout>
  )
}

export const query = graphql`
  query SolutionPageData($slug: [String]) {
    cms {
      entry(slug: $slug, section: "solutions") {
        id
        ... on Cms_solutions_solutions_Entry {
          id
          metaTitle
          metaDescription
          metaImage {
            url(width: 1200, height: 630)
          }
          title
          section1Text
          coverImage {
            url(width: 1280, height: 720)
          }
          coverImageRetina: coverImage {
            url(width: 2560, height: 1440)
          }
          solutionPageData {
            ... on Cms_solutionPageData_imageSection1_BlockType {
              id
              typeHandle
              imageLeft
              sectionTitle
              description
              image {
                url(width: 1440)
              }
            }
            ... on Cms_solutionPageData_imageSection2_BlockType {
              id
              typeHandle
              buttonLink
              buttonLabel
              body
              sectionTitle
              image {
                url(width: 1440)
              }
            }
            ... on Cms_solutionPageData_featuresSection_BlockType {
              id
              typeHandle
              feature1
              feature2
              feature3
              feature4
              feature5
              feature6
              sectionTitle
              description
            }
            ... on Cms_solutionPageData_cta2_BlockType {
              id
              typeHandle
              sectionTitle
              description
              buttonLink
              buttonLabel
            }
            ... on Cms_solutionPageData_contactForm_BlockType {
              id
              typeHandle
              recipients
              description
              buttonLabel
              sectionTitle
            }
            ... on Cms_solutionPageData_richTextField_BlockType {
              id
              typeHandle
              body
            }
            ... on Cms_solutionPageData_cta1_BlockType {
              id
              typeHandle
              description
              sectionTitle
            }
            ... on Cms_solutionPageData_faqItem_BlockType {
              id
              typeHandle
              question
              answer
            }
            ... on Cms_solutionPageData_faqTitle_BlockType {
              id
              typeHandle
              sectionTitle
            }
          }
        }
      }
    }
  }
`
